import {useAuth} from '../../auth'
import {staffCan, StaffSessionModel} from '../../auth/core/staffAccess'

type StaffUser = {staff?: StaffSessionModel | null} | null | undefined

/**
 * ASA's staff for «زنجیره تأمین» (docs/staff-access.md, section `supplyChain`): a session opened from the CRM whose role
 * reaches the section reads the staff area and every business's requests; a change needs «مدیریت»
 * (useStaffManages('supplyChain')). The server's SupplyChainAccess holds the same rule.
 */
export const isSupplyChainStaff = (user: StaffUser): boolean => staffCan(user, 'supplyChain')

export const useSupplyChainStaff = (): boolean => {
  const {currentUser} = useAuth()
  return isSupplyChainStaff(currentUser)
}
